import { render, staticRenderFns } from "./OrgBillingDetailsForm.vue?vue&type=template&id=54cd859c&scoped=true&"
import script from "./OrgBillingDetailsForm.vue?vue&type=script&lang=js&"
export * from "./OrgBillingDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./OrgBillingDetailsForm.vue?vue&type=style&index=0&id=54cd859c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd859c",
  null
  
)

export default component.exports